import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { SmartButton } from "@mui/icons-material";
import { TextField, responsiveFontSizes } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  setState,
  GetBlockedCustomersConsumption,
  EditOrders,
  GetQuotaDetailsForScenario,
} from "../reviewSlice";
import { orderBy } from "lodash";
const ModifyOrders = () => {
  const dispatch = useDispatch();
  const review = useSelector((state) => state.review);
  const {
    customerList,
    TotalModifiedQtyUoM,
    TotalAvailableQty,
    openModifyOrders,
    orderParameters,
  } = review;
  const rows = customerList;

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [orderByColumn, setOrderByColumn] = useState("");
  const [order, setOrder] = useState("asc");
  const [modifiedQtyPacks, setModifiedQtyPacks] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const onClose = () => {
    dispatch(setState("openModifyOrders", false));
  };

  const onRefresh = () => {
    dispatch(setState("customerList", []));
    dispatch(GetBlockedCustomersConsumption(orderParameters));
  };
  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };
  const onSave = () => {
    for (let i = 0; i < customerList.length; i++) {
      for (let j = 0; j < customerList[i].details.length; j++) {
        if (
          customerList[i].details[j].modifiedQtyPacks == undefined ||
          customerList[i].details[j].modifiedQtyPacks == null ||
          customerList[i].details[j].modifiedQtyPacks == ""
        ) {
          showMessage(
            "Please enter a value for modified quantity packs",
            "info"
          );
          return;
        } else if (
          parseFloat(customerList[i].details[j].modifiedQtyPacks) >
          parseFloat(customerList[i].details[j].intendedQtyPacks)
        ) {
          showMessage(
            "Modified quantity packs cannot be greater than Intended quatity packs",
            "info"
          );
          return;
        }
      }
    }
    let obj = {
      scenarioId: orderParameters.scenarioId,
      CountryId: orderParameters.countryId,
      customer: customerList,
    };
    const newObj = {
      scenarioId: orderParameters.scenarioId,
      quotaId: orderParameters.selectedQuotaID,
    };
    dispatch(EditOrders(obj)).then(() =>
      dispatch(GetQuotaDetailsForScenario(newObj))
    );
    dispatch(setState("openModifyOrders", false));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleModifiedQtyPacks = (details) => (e) => {
    if (e.target.value === "-") {
      return;
    }
    if (Number(e.target.value) >= 0) {
      let list = JSON.parse(JSON.stringify(customerList));
      let index;
      if(details.customerGroupId !== undefined && details.customerGroupId !== null && details.customerGroupId > 0 && details.customerGroupId !== "") {
        index = list.findIndex(
          (item) => item.customerGroupId === details.customerGroupId
        );
      }else{
        index = list.findIndex(
          (item) => item.customerId === details.customerId
        );
      }
      let innerIndex = list[index].details.findIndex(
        (item) => item.dataSourceRowId === details.dataSourceRowId
      );
      list[index].details[innerIndex].modifiedQtyPacks = e.target.value;
      for (let i = 0; i < list.length; i++) {
        let modifyQtyUoM = 0;
        for (let j = 0; j < list[i].details.length; j++) {
          if (
            list[i].details[j].intendedQtyPacks ==
            list[i].details[j].modifiedQtyPacks
          ) {
            modifyQtyUoM += Number(list[i].details[j].intendedQtyUoM);
          } else {
            modifyQtyUoM +=
              list[i].details[j].modifiedQtyPacks * list[i].details[j].packSize;
          }
        }
        list[i].modifiedQtyUoM = modifyQtyUoM;
      }
      dispatch(setState("customerList", list));
      let TtlModifiedQtyUoM = list.reduce(
        (total, element) => total + parseFloat(element.modifiedQtyUoM),
        0
      );
      let TtlAvailableQty = list.reduce(
        (total, element) => total + parseFloat(element.availableQuota),
        0
      );
      dispatch(setState("TotalModifiedQtyUoM", TtlModifiedQtyUoM));
      dispatch(setState("TotalAvailableQty", TtlAvailableQty));
    }
  };

  const paginatedData = customerList.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <div>
      <Dialog
        open={openModifyOrders}
        onClose={onClose}
        fullWidth
        maxWidth={"lg"}
      >
        <DialogTitle
          sx={{ fontSize: "16px", fontWeight: "700", color: "#007DC3" }}
        >
          Modify Orders
        </DialogTitle>
        <DialogContent>
          <Box>
            <Paper>
              <TableContainer
                style={{
                  maxHeight: "calc(100vh - 330px)",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                <Table
                  component={Paper}
                  style={{ overflowY: "scroll", overflowX: "hidden" }}
                  stickyHeader
                  // sx={{ minWidth: 750 }}
                  // aria-labelledby="tableTitle"
                  // size={'large'}
                >
                  <TableHead
                    sx={{
                      "& th": {
                        backgroundColor: "rgb(235, 245, 255)",
                      },
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <TableRow>
                      <TableCell>Customer Group Name</TableCell>

                      <TableCell>Customer</TableCell>
                      <TableCell>Order Number</TableCell>
                      <TableCell>Line Item Number</TableCell>
                      <TableCell>SKU Name</TableCell>
                      <TableCell>Intended Quantity (UoM)</TableCell>
                      <TableCell>Intended Quantity (Packs)</TableCell>
                      <TableCell>Modified Quantity (Packs)</TableCell>
                      <TableCell>Modified Quantity (UoM)</TableCell>
                      <TableCell>Available Quota (UoM)</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {paginatedData?.map((row, index) => {
                      //const isItemSelected = isSelected(row.id);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <>
                          <TableRow
                            hover
                            //onClick={(event) => handleClick(event, row.id)}
                            role="checkbox"
                            //aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={row.id}
                            //selected={isItemSelected}
                            sx={{ cursor: "pointer" }}
                          >
                            {/* <TableCell padding="checkbox">
                              <Checkbox
                                color="primary"
                                checked={isItemSelected}
                                inputProps={{
                                  'aria-labelledby': labelId,
                                }}
                              />
                            </TableCell> */}
                            <TableCell
                              component="th"
                              id={labelId}
                              scope="row"
                              padding="none"
                            >
                              {row?.customerGroupName?.length > 20
                                ? row.customerGroupName.substring(0, 19) + "..."
                                : row.customerGroupName}
                            </TableCell>
                            <TableCell align="left">
                              {" "}
                              <strong>
                                {row?.customerName?.length > 20
                                  ? row.customerName.substring(0, 19) + "..."
                                  : row.customerName}
                              </strong>
                            </TableCell>
                            <TableCell align="left">{""}</TableCell>
                            <TableCell align="left">{""}</TableCell>
                            <TableCell align="left">{""}</TableCell>
                            <TableCell align="left">
                              <strong>{row?.intendedQtyUoM}</strong>
                            </TableCell>
                            <TableCell align="left">
                              <strong>{row?.intendedQtyPacks}</strong>
                            </TableCell>
                            <TableCell align="left">{""}</TableCell>
                            <TableCell align="left">
                              <strong>{row?.modifiedQtyUoM}</strong>
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{
                                color:
                                  Number(row?.availableQuota) <
                                  Number(row?.modifiedQtyUoM)
                                    ? "red"
                                    : "green",
                              }}
                            >
                              <strong>{row?.availableQuota}</strong>
                            </TableCell>
                          </TableRow>
                          {row?.details.map((details, ind) => {
                            return (
                              <>
                                <TableRow hover tabIndex={-1} key={row.id}>
                                  <TableCell
                                    component="th"
                                    id={labelId}
                                    scope="row"
                                    padding="none"
                                  >
                                    {row?.customerGroupName?.length > 20
                                      ? row.customerGroupName.substring(0, 19) +
                                        "..."
                                      : row.customerGroupName}
                                  </TableCell>
                                  <TableCell align="left">
                                    {details?.customerName?.length > 20
                                      ? row.customerName.substring(0, 19) +
                                        "..."
                                      : row.customerName}
                                  </TableCell>
                                  <TableCell align="left">
                                    {details?.salesOrder}
                                  </TableCell>
                                  <TableCell align="left">
                                    {details?.salesItemNo}
                                  </TableCell>
                                  <TableCell align="left">
                                    {details?.skuName}
                                  </TableCell>
                                  <TableCell align="left">
                                    {details?.intendedQtyUoM}
                                  </TableCell>
                                  <TableCell align="left">
                                    {details?.intendedQtyPacks}
                                  </TableCell>
                                  <TableCell align="left">
                                    <TextField
                                      type="number"
                                      inputProps={{ min: 0 }}
                                      value={details?.modifiedQtyPacks}
                                      onChange={handleModifiedQtyPacks(details)}
                                    />
                                  </TableCell>
                                  <TableCell align="left">
                                    {details?.intendedQtyPacks ==
                                    details?.modifiedQtyPacks
                                      ? details?.intendedQtyUoM
                                      : details?.modifiedQtyPacks *
                                        details?.packSize}
                                  </TableCell>
                                  <TableCell align="left">{"N/A"}</TableCell>
                                </TableRow>
                              </>
                            );
                          })}
                        </>
                      );
                    })}
                    <TableRow hover tabIndex={-1}>
                      {/* <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              checked={isItemSelected}
                              inputProps={{
                                'aria-labelledby': labelId,
                              }}
                            />
                          </TableCell> */}
                      <TableCell></TableCell>
                      <TableCell align="left">{""}</TableCell>
                      <TableCell align="left">{""}</TableCell>
                      <TableCell align="left">{""}</TableCell>
                      <TableCell align="left">{""}</TableCell>
                      <TableCell align="left">{""}</TableCell>
                      <TableCell align="left">{""}</TableCell>
                      <TableCell
                        align="left"
                        style={{
                          backgroundColor:
                            TotalAvailableQty < TotalModifiedQtyUoM
                              ? "red"
                              : "green",
                        }}
                      >
                        <strong>{"Total Modified"}</strong>
                      </TableCell>
                      <TableCell align="left">
                        <strong>{TotalModifiedQtyUoM}</strong>
                      </TableCell>
                      <TableCell align="left">
                        <strong>{TotalAvailableQty}</strong>
                      </TableCell>
                    </TableRow>

                    {/* {emptyRows > 0 && (
                      <TableRow
                        style={{
                          height: (dense ? 33 : 53) * emptyRows,
                        }}
                      >
                        <TableCell colSpan={6} />
                      </TableRow>
                    )} */}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[20, 50, 100]}
                component="div"
                count={customerList?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onRefresh}
            color="primary"
            variant={"outlined"}
            sx={{ marginBottom: "10px" }}
          >
            Refresh
          </Button>
          <Button
            onClick={onSave}
            color="primary"
            variant={"contained"}
            sx={{ marginRight: "18px", marginBottom: "10px" }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ModifyOrders;
